import UpsellTrigger from '@alltrails/amplitude/enums/UpsellTrigger';
import Typography from '@alltrails/core/components/Typography';
import useUser from '@alltrails/context/hooks/useUser';
import usePlans from '@alltrails/context/hooks/usePlans';
import type PurchaseTier from '@alltrails/core/types/PurchaseTier';
import PeakLogoBadge from '@alltrails/denali/components/SubscriptionBadge/Logo/Peak';
import PlusLogoBadge from '@alltrails/denali/components/SubscriptionBadge/Logo/Plus';
import type SubscriptionUser from '@alltrails/types/SubscriptionUser';
import PeakFeatureList from '../PeakFeatureList/PeakFeatureList';
import PlanSelection from '../PlanSelection/PlanSelection';
import styles from './UpsellContent.module.scss';
import TierSubheading from './TierSubheading';

type Props = {
  tierSelected: PurchaseTier;
  setTierSelected: (tier: PurchaseTier) => void;
  upsellTrigger: UpsellTrigger;
  promoEligibleHeading: React.ReactNode;
  heading: React.ReactNode;
  showPlusFirst?: boolean;
  hidePeak?: boolean;
  subscriptionUser: SubscriptionUser | null;
};

const GenericUpsellContent = ({
  tierSelected,
  setTierSelected,
  upsellTrigger,
  promoEligibleHeading,
  heading,
  showPlusFirst,
  hidePeak = false,
  subscriptionUser
}: Props) => {
  const user = useUser();
  const plans = usePlans();
  const isPromoEligible = !user || user?.isPromoEligible;
  const isPlus = user?.subscriptionTier === 'plus';

  return (
    <>
      {isPlus && !hidePeak ? (
        <>
          <PeakLogoBadge size="md" variant="full" className={styles.logo} />
          <Typography variant="heading400">{isPromoEligible ? promoEligibleHeading : heading}</Typography>
          <TierSubheading tier="peak" />
        </>
      ) : hidePeak ? (
        <>
          <PlusLogoBadge size="md" variant="full" className={styles.logo} />
          <Typography variant="heading400">{isPromoEligible ? promoEligibleHeading : heading}</Typography>
          <TierSubheading tier="plus" />
        </>
      ) : (
        <>
          <Typography variant="heading400">{isPromoEligible ? promoEligibleHeading : heading}</Typography>
          <PlanSelection
            isPromoEligible={isPromoEligible}
            plans={plans}
            tierSelected={tierSelected}
            setTierSelected={setTierSelected}
            showPlusFirst={showPlusFirst}
            hidePeak={hidePeak}
            trigger={upsellTrigger}
            subscriptionUser={subscriptionUser}
          />
        </>
      )}
      <PeakFeatureList tierSelected={tierSelected} upsellTrigger={upsellTrigger} />
    </>
  );
};

export default GenericUpsellContent;
